<template >

  <div class="">
    <el-col class="basic-margin">
      <list-template
        ref="list-template"
        :hasSearch="false"
        actionUrl="business/findBusinessProducts.action"
        :queryParams="searchInfo">

        <template slot="searchButton" scope="scope">

          <el-button type="primary" style="margin-right:20px;" @click="toReleaseProduct()">发布产品</el-button>

        </template>

        <template slot="item" scope="scope">

          <div >
            <el-card  class="basic-margin" v-for="data in scope.datas">
              <el-row>
                <el-col :span="2" style="text-align:left;margin-left:20px;">
                  <img v-if="data.productImgUrl" :src="imageUrl+data.productImgUrl.split(',')[0]" style="width:80pt;height:80pt;"></img>
                </el-col>
                <el-col :span="14" style="text-align:left;margin-left:20px;">
                  <p style="font-size:1.8rem;">{{data.productName}}</p>
                  <p style="color:#666;font-size:1.4rem;margin-top:10pt;">价格:{{data.priceInfo}}</p>
                  <p style="color:#666;font-size:1.4rem;margin-top:20pt;"> {{data.createTime | dateFormat}} </p>
                </el-col>

                <el-col :span="4" style="text-align:left;margin-left:20px;">
                  <el-button v-delete="{id:data.id,action:'business/deleteBusinessProducts.action'}">删除</el-button>
                  <el-button type="primary" @click="toEditProduct(data.id)">编辑</el-button>
                </el-col>
              </el-row>
            </el-card>
          </div>

        </template>
      </list-template>
    </el-col>
  </div>
</template>
<style scpoed >
	.top-margin{
		margin-left:5px
	}
</style>

<script>
import BusinessModel from '../../../framework/models/businessModel'
import Config from '../../../framework/configs/Config'
import BasicPager from '../../../mixins/BasicPager'
import ListTemplate from '../../../components/ListTemplate'
export default {
  name: 'thematic-management',
  extends: BasicPager,
  data: function () {
    return {
      datas: [],
      searchInfo: {
        businessId: null,
        keyword: ''
      },
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0, // 总条数
      dialogVisible: false,
      imageUrl: Config.imageUrl
    }
  },
  components: {
    BusinessModel,
    ListTemplate
  },
  created: function () {
    let that = this
    let params = this.$route.params
    that.searchInfo.businessId = params.businessId
  },
  methods: {
    toReleaseProduct: function () {
      this.$router.push({ name: '添加产品', params: { 'businessId': this.searchInfo.businessId } })
    },
    toEditProduct: function (id) {
      this.$router.push({ name: '修改产品', params: { businessId: this.searchInfo.businessId, businessProductId: id } })
    }
  }
}
</script>
